<template>
<!-- 收款管理 -->
<div class="viewContainer">
  <!-- 顶部搜索框 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <el-form class="findform">
        <el-form-item label="主体名称：" style="display:flex;width:30%">
          <el-input v-model="keyword" placeholder="请输入主体名称" maxlength="20" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="申请日期：" style="display:flex;width:30%">
          <el-date-picker type="daterange" :title="value6" v-model="value6" value-format="yyyy-MM-dd" style="width:90%;"
          range-separator="至" start-placeholder="开始日期" @change="changetime" end-placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="状态：" style="display:flex;width:30%">
          <el-select v-model="isIn" style="width:90%;">
            <el-option v-for="(item,index) in stateArr" :key="index" :value="item.statusid" :label="item.statusname"/>
          </el-select>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">收款管理</p>
    </section>
    <div class="table_container">
      <el-table :data="users" stripe border>
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="主体名称" align="center">
          <template scope="scope">{{scope.row.merchantname}}</template>
        </el-table-column>
        <el-table-column label="所在城区" align="center">
          <template scope="scope">{{scope.row.areaname}}</template>
        </el-table-column>
        <el-table-column label="主体类型" align="center" >
          <template scope="scope">{{scope.row.organizationtypename}}</template>
        </el-table-column>
        <el-table-column label="申请日期" align="center">
          <template scope="scope">{{scope.row.createtime}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.statusname}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right;"/>
    </div>
  </div>
</div>
</template>
<script>
import { collectionsettingGetstatuslist, collectionsettingGetlist } from "../../api/shopWindow";
export default {
  data() {
    return {
      show3:true,
      keyword: "", // 主体名称
      createDateB: "", // 日期开始日期
      createDateE: "", // 日期结束日期
      isIn: 'ALL', // 状态
      stateArr: [], // 状态集合
      users: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      value6: '', // 引流时间
    };
  },
  methods: {
    // 获取收款管理列表
    gettogetherlist() {
      var loginParams = {
        merchantname: this.keyword, // 主体名称
        btime: this.createDateB, // 开始时间
        etime: this.createDateE, // 结束时间
        status: this.isIn, // 状态
        pageindex: this.pageIndex,
        pagesize: this.pageSize
      };
      collectionsettingGetlist(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.users = data.resultObj.list;
          this.total = data.resultObj.totalcount; // 总条数
        } else {
          this.users = [];
        }
      });
    },
    // 申请日期
    changetime() {
      if( this.value6 + "" == "null" ){
        this.value6 = ["",""]
      }
      this.createDateB = this.value6[0];
      this.createDateE = this.value6[1];
    },
    // 重置
    fnReset() {
      this.keyword = ""; // 主体名称
      this.value6 = ''; // 日期
      // this.createDateB = '';
      // this.createDateE = '';
      this.isIn = 'ALL'; // 状态
      // this.pageIndex = 1;
      // this.gettogetherlist();
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.gettogetherlist();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.gettogetherlist();
    },
    // 获取收款设置状态列表
    getskszState() {
      collectionsettingGetstatuslist('').then(data => {
        this.stateArr = data.resultObj;
      });
    },
  },
  mounted() {
    this.gettogetherlist();
    this.getskszState(); // 获取收款设置状态列表
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// collectionManagement.vue?74adedee